import React from 'react';
import Icon, { IconType } from '../../../icons/Icon';
import { Divider } from '../../Divider';
import ModalTitle from '../components/ModalTitle';
import Modal from '../Modal';

interface ActionModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  width?: string;
}

export default function ActionModal({ open, setOpen, title, children, footer, className, width }: ActionModalProps) {
  return (
    <Modal open={open} setOpen={setOpen}>
      <div
        className={`flex h-full min-w-[720px] flex-col ${className}`}
        style={{ width, maxWidth: 'min(80dvh, 1280px)' }}
      >
        <div className='modal-x flex h-[64px] items-center justify-between gap-4'>
          <ModalTitle text={title} />
          <Icon type={IconType.xClose} stroke={'stroke-gray-400'} onClick={() => setOpen(false)} />
        </div>

        {footer ? <ActionModalPane footer={footer}>{children}</ActionModalPane> : children}
      </div>
    </Modal>
  );
}

interface ActionModalPaneProps {
  footer: React.ReactNode;
  children: React.ReactNode;
}

export function ActionModalPane({ footer, children }: ActionModalPaneProps) {
  return (
    <>
      <ActionModalBody>{children}</ActionModalBody>
      <Divider />
      <ActionModalFooter>{footer}</ActionModalFooter>
    </>
  );
}

export function ActionModalBody({ children }: { children: React.ReactNode }) {
  return <div className='modal-x flex-grow pb-8 pt-4'>{children}</div>;
}

export function ActionModalFooter({ children }: { children: React.ReactNode }) {
  return <div className='modal-x py-3'>{children}</div>;
}
